import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=b6373d72&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QForm,QInput,QCheckbox,QSelect,QDialog,QCard,QCardSection,QAvatar,QCardActions,QSeparator,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QForm,QInput,QCheckbox,QSelect,QDialog,QCard,QCardSection,QAvatar,QCardActions,QSeparator,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
